import { initTelemetry } from '@medcom/shared-ui/utils/telemetry.ts';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { AppRoot } from './App';
import { oidcConfig } from './oidcConfig.ts';

initTelemetry({
  url: window._env_.FARO_URL,
  apiKey: window._env_.FARO_API_KEY,
  appName: 'befunde-ui',
  version: window._runtime_.VERSION,
  environment: window._env_.ENV_TAG,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  //strict mode calls hooks twice
  // <StrictMode>
  <AuthProvider {...oidcConfig}>
    <AppRoot />
  </AuthProvider>
  // </StrictMode>
);
